import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { PixiPlugin } from "gsap/PixiPlugin";
import * as PIXI from "pixi.js";
import { BitmapText } from "pixi.js";
import { isSuperQuickBtnOnGlobal } from "../../config/GlobalVariableConfig";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";
import { wait } from "../../core/utils";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";

gsap.registerPlugin(PixiPlugin, MotionPathPlugin);
PixiPlugin.registerPIXI(PIXI);
type textMeter = {
    text: BitmapText;
    reelNumber: number;
    posNumber: number;
};

export class WinMeterContainer extends DisplayObject {
    private multiplierTextInstances: textMeter[] = [];
    private labelName: string = "multiplier_";
    private symbolList: Spine[] = [];
    private activeTweens: gsap.core.Tween[] = [];
    private centerOffset: number = 110;
    //private multiplieryOffset: number = 10;
    private totalMulti: number = 0;
    public trailPosX: number = 100;
    public trailPosY: number = 100;
    //private multiplierImpact: Spine;

    constructor(config: IDisplayObject) {
        super(config);
        //this.multiplierImpactCont();
    }

    public getMeter(rowNum: number, posNum: number): textMeter {
        return this.multiplierTextInstances.find(a => a.reelNumber == rowNum && a.posNumber == posNum)
    }

    public setupMeter(rowNum: number, posNum: number, multiplier: number = 1) {
        //this.symbolList = [];
        //this.multiplierTextInstances = [];
        const multVal = multiplier;
        const multText = new BitmapText({
            text: `${multVal}x`,
            style: {
                fontFamily: '3God_coin',
                fontSize: 60
            }
        });
        multText.label = this.labelName + rowNum + "_" + posNum;
        multText.anchor = 0.5;
        multText.visible = false;
        this.multiplierTextInstances.push({ text: multText, reelNumber: rowNum, posNumber: posNum });
        multText.scale = 0;
        this.addChild(multText);
    }

    // public multiplierImpactCont() {
    //     this.multiplierImpact = Spine.from({
    //         skeleton: "multiplierSkel",
    //         atlas: "multiplierAtlas"
    //     })
    //     this.addChild(this.multiplierImpact);
    //     this.multiplierImpact.visible = false;
    //     this.multiplierImpact.position.set(495, -105);
    // }

    public revealMultiplier(id: string, multiplier: number, symbol: Spine | null) {
        let multiplierInst = this.getChildByLabel(this.labelName + id) as BitmapText;
        multiplierInst.style.fontSize = 60;//(symId === GameConstants.WINDMILL_SYMBOL_ID) ? 100 : 50;
        multiplierInst.text = `${multiplier}x`;
        multiplierInst.scale = 1;
        multiplierInst.visible = true;
        //const slotNames = symbol.skeleton.data.slots.map(s => s.name);
        //console.log(slotNames);
        //(symbol) && (symbol.addSlotObject("multiplier", multiplierInst));
        (symbol) && (symbol.addSlotObject("multiplier", multiplierInst));
        this.symbolList.push(symbol);
    }

    private trackTween(tween: gsap.core.Tween | null | undefined): void {
        if (!tween) return;
        this.activeTweens.push(tween);
    }

    private clearActiveTweens(): void {
        this.activeTweens.forEach((tween) => tween?.kill());
        this.activeTweens = [];
    }

    public async collectSingleMultiplier(index: number, posNum: number): Promise<void> {
        // const promises: Promise<void>[] = [];
        //let texts = this.multiplierTextInstances;
        const duration = isSuperQuickBtnOnGlobal ? 0.25 : 0.75;
        const center = new PIXI.Point(100, 100);
        center.y -= this.centerOffset;
        const txt = this.multiplierTextInstances[index].text;
        //texts.forEach((txt, i) => {
        //const promise = new Promise<void>((resolve) => {
        return new Promise<void>((resolve) => {
            console.log(" collectAllMultipliersSpiral ===> ", txt.text);
            const start = this.toLocal(txt.getGlobalPosition());
            const fly = new BitmapText({
                text: txt.text,
                style: txt.style
            });
            fly.x = start.x;
            fly.y = start.y;
            fly.anchor.set(0.5);
            fly.scale.set(0.6);
            fly.alpha = 1;
            fly.label = "flyingMultiplier";
            this.addChild(fly);
            txt.visible = false;
            let obj = this.symbolList[index].getSlotObject("blue_3X");
            obj?.destroy();
            this.symbolList[index].removeSlotObject("blue_3X");
            const path = [
                { x: start.x, y: start.y },
                {
                    x: posNum > 0 ? (start.x + 100) : (start.x - 100),  // lifted for arc
                    y: (start.y + 100)  // lifted for arc
                },
                { x: center.x, y: center.y + 100 }
            ];
            const tween = gsap.to(fly, {
                delay: /*i */ (isSuperQuickBtnOnGlobal ? 0.005 : 0.04),
                motionPath: {
                    path: path,
                    curviness: 1.5,
                    autoRotate: false
                },
                x: center.x,
                y: center.y,
                //radius: 0,
                duration: duration,
                ease: "sine.inOut",
                onStart: () => {
                    txt.visible = false;
                    let obj = this.symbolList[index].getSlotObject("blue_3X");
                    obj?.destroy();
                    this.symbolList[index].removeSlotObject("blue_3X");
                },
                onComplete: () => {
                    this.activeTweens = this.activeTweens.filter((activeTween) => activeTween !== tween);
                    //this.multiplierImpact.visible = true;
                    //this.multiplierImpact.state.setAnimation(0, "animation", false);
                    this.totalMulti += Number(fly.text.slice(0, -1));
                    this.removeChild(fly);
                    fly.destroy();
                    //this.showTotalWinMeter();
                    resolve();
                }
            });
            this.trackTween(tween);
        });
        //promises.push(promise);
        //});
        //if (promises.length > 0)
        // await Promise.all(promises);
    }

    // public async collectAllMultipliers(index: number, posNum: number): Promise<void> {
    //     const promises: Promise<void>[] = [];
    //     //let texts = this.multiplierTextInstances;
    //     const duration = isSuperQuickBtnOnGlobal ? 0.25 : 0.75;
    //     const center = new PIXI.Point(100, 100);
    //     center.y -= this.centerOffset;
    //     const txt = this.multiplierTextInstances[index];
    //     //texts.forEach((txt, i) => {
    //     const promise = new Promise<void>((resolve) => {
    //         //return new Promise<void>((resolve) => {
    //         console.log(" collectAllMultipliersSpiral ===> ", txt.text);
    //         const start = this.toLocal(txt.getGlobalPosition());
    //         const fly = new BitmapText({
    //             text: txt.text,
    //             style: txt.style
    //         });
    //         fly.x = start.x;
    //         fly.y = start.y;
    //         fly.anchor.set(0.5);
    //         fly.scale.set(0.6);
    //         fly.alpha = 1;
    //         fly.label = "flyingMultiplier";
    //         this.addChild(fly);
    //         txt.visible = false;
    //         let obj = this.symbolList[index].getSlotObject("blue_3X");
    //         obj?.destroy();
    //         this.symbolList[index].removeSlotObject("blue_3X");
    //         const path = [
    //             { x: start.x, y: start.y },
    //             {
    //                 x: posNum > 0 ? (start.x + 100) : (start.x - 100),  // lifted for arc
    //                 y: (start.y + 100)  // lifted for arc
    //             },
    //             { x: center.x, y: center.y + 100 }
    //         ];
    //         gsap.to(fly, {
    //             delay: /*i */ (isSuperQuickBtnOnGlobal ? 0.005 : 0.04),
    //             motionPath: {
    //                 path: path,
    //                 curviness: 1.5,
    //                 autoRotate: false
    //             },
    //             x: center.x,
    //             y: center.y,
    //             //radius: 0,
    //             duration: duration,
    //             ease: "sine.inOut",
    //             onStart: () => {
    //                 txt.visible = false;
    //                 let obj = this.symbolList[index].getSlotObject("blue_3X");
    //                 obj?.destroy();
    //                 this.symbolList[index].removeSlotObject("blue_3X");
    //             },
    //             onComplete: () => {
    //                 //this.multiplierImpact.visible = true;
    //                 //this.multiplierImpact.state.setAnimation(0, "animation", false);
    //                 this.totalMulti += Number(fly.text.slice(0, -1));
    //                 this.removeChild(fly);
    //                 fly.destroy();
    //                 //this.showTotalWinMeter();
    //                 resolve();
    //             }
    //         });
    //         //});
    //         promises.push(promise);
    //     });
    //     if (promises.length > 0)
    //         await Promise.all(promises);
    // }

    // public resize(screenWidth: number, screenHeight: number) {
    //     // if (screenWidth > screenHeight) {
    //     //     this.multiplierImpact.position.set(this.totalText.position.x, this.totalText.position.y);
    //     // }
    //     // else {
    //     //     this.multiplierImpact.position.set(this.totalText.position.x, this.totalText.position.y);
    //     // }
    // }

    private getBitmapTextByLabel(label: string): BitmapText {
        return this.multiplierTextInstances.find(item => item.text.label === label)?.text;
    }

    private playDoubleMultiplierPresentation(
        textObj: BitmapText,
        newValue: number,
        start: PIXI.Point,
        staggerDelay: number,
        onDone: () => void
    ): void {
        const quick = isSuperQuickBtnOnGlobal;
        const duration = quick ? 0.35 : 0.7;
        const spread = quick ? 28 : 45;
        const liftAmount = quick ? 8 : 12;
        const splitPeakScale = 1.25;

        const left = new BitmapText({ text: textObj.text, style: textObj.style });
        const right = new BitmapText({ text: textObj.text, style: textObj.style });
        left.anchor.set(0.5);
        right.anchor.set(0.5);
        left.visible = false;
        right.visible = false;
        left.scale.set(1);
        right.scale.set(1);
        this.addChild(left, right);
        left.position.set(start.x, start.y);
        right.position.set(start.x, start.y);

        const anim = { p: 0 };
        textObj.visible = false;

        const tween = gsap.to(anim, {
            p: 1,
            delay: staggerDelay,
            duration,
            ease: "sine.inOut",
            onUpdate: () => {
                left.visible = true;
                right.visible = true;
                const p = anim.p;
                if (p < 0.5) {
                    const t = p * 2;
                    left.x = start.x - spread * t;
                    right.x = start.x + spread * t;
                    // const scale = 1 + (splitPeakScale - 1) * t;
                    const scale = 1;
                    left.scale.set(scale);
                    right.scale.set(scale);
                    left.alpha = 1;
                    right.alpha = 1;
                } else {
                    const t = (p - 0.5) * 2;
                    left.x = start.x - spread * (1 - t);
                    right.x = start.x + spread * (1 - t);
                    // const mergeShrink = 1 - 0.4 * t;
                    // const scale = splitPeakScale * mergeShrink;
                    const scale = 1 - 0.2 * t
                    left.scale.set(scale);
                    right.scale.set(scale);
                    left.alpha = 1 - t;
                    right.alpha = 1 - t;
                }
                const lift = Math.sin(p * Math.PI) * liftAmount;
                left.y = start.y - lift;
                right.y = start.y - lift;
            },
            onComplete: () => {
                this.activeTweens = this.activeTweens.filter((activeTween) => activeTween !== tween);
                const impactFx = Spine.from({
                    skeleton: "doubleEffectSkel",
                    atlas: "doubleEffectAtlas",
                });
                const anims = impactFx.skeleton.data.animations;
                const impactAnimName = anims.length > 0 ? anims[0].name : "animation";
                impactFx.position.set(start.x, start.y);
                impactFx.scale.set(0.5);
                this.addChild(impactFx);
                impactFx.state.setAnimation(0, impactAnimName, false).listener = {
                    complete: () => {
                        impactFx.state.clearListeners();
                        this.removeChild(impactFx);
                        impactFx.destroy();
                    },
                };

                this.removeChild(left, right);
                left.destroy();
                right.destroy();
                textObj.text = `${newValue}x`;
                textObj.visible = true;
                gsap.killTweensOf(textObj.scale);
                textObj.scale.set(1);
                const popDur = quick ? 0.15 : 0.25;
                gsap.fromTo(
                    textObj.scale,
                    { x: splitPeakScale, y: splitPeakScale },
                    {
                        x: 1,
                        y: 1,
                        duration: popDur,
                        ease: "back.out(2)",
                        onComplete: onDone,
                    }
                );
            },
        });
        this.trackTween(tween);
    }

    private multiplierHitPop(textObj: BitmapText): void {
        gsap.killTweensOf(textObj.scale);
        const sx = textObj.scale.x;
        const sy = textObj.scale.y;
        const popScale = 1.05;
        const quick = isSuperQuickBtnOnGlobal;
        const tween = gsap.fromTo(
            textObj.scale,
            { x: sx, y: sy },
            {
                x: sx * popScale,
                y: sy * popScale,
                duration: quick ? 0.07 : 0.1,
                ease: "power2.out",
                yoyo: true,
                repeat: 1,
            }
        );
        this.trackTween(tween);
    }

    public sortTheOrder(): void {
        this.multiplierTextInstances.sort(
            (a, b) => a.reelNumber - b.reelNumber || a.posNumber - b.posNumber
        );
    }

    public async doubleAllMultipliersInSerial(rowNum: number, posNum: number): Promise<void> {

        const promises: Promise<void>[] = [];
        let texts = this.multiplierTextInstances;
        const targetMultiInst = this.getBitmapTextByLabel(this.labelName + rowNum + "_" + posNum) as BitmapText
        //const target = this.toLocal(targetMultiInst.getGlobalPosition());

        sound.play(SoundConstants.HADE_F, { volume: 1 });
        for (let i = 0; i < texts.length; i++) {
            if (i != 0) await wait(100);
            const txt = texts[i].text;
            if (txt != targetMultiInst) {
                const start = this.toLocal(txt.getGlobalPosition());
                const previousValue = Number(txt.text.slice(0, -1));
                const newValue = previousValue + previousValue;
                const stagger = i * (isSuperQuickBtnOnGlobal ? 0.005 : 0.04);
                const promise = new Promise<void>((resolve) => {
                    console.log(" collectAllMultipliersSpiral ===> ", txt.text);
                    this.playDoubleMultiplierPresentation(txt, newValue, start, stagger, resolve);
                });
                promises.push(promise);
            }
        }
        if (promises.length > 0)
            await Promise.all(promises);
    }

    public async AddAllMultipliersInSerial(rowNum: number, posNum: number): Promise<void> {

        const promises: Promise<void>[] = [];
        let texts = this.multiplierTextInstances;
        const duration = isSuperQuickBtnOnGlobal ? 0.25 : 0.75;
        const targetMultiInst = this.getBitmapTextByLabel(this.labelName + rowNum + "_" + posNum) as BitmapText
        //const target = this.toLocal(targetMultiInst.getGlobalPosition());

        const start = this.toLocal(targetMultiInst.getGlobalPosition());
        sound.play(SoundConstants.ZEUS_F, { volume: 1 });
        for (let i = 0; i < texts.length; i++) {
            if (i != 0) await wait(100);
            const txt = texts[i].text;
            if (txt != targetMultiInst) {
                const textMulti = Number(txt.text.slice(0, -1));
                const target = this.toLocal(txt.getGlobalPosition());
                const center = new PIXI.Point(target.x, target.y);
                center.y -= this.centerOffset;
                const promise = new Promise<void>((resolve) => {
                    console.log(" collectAllMultipliersSpiral ===> ", txt.text);
                    const fly = new BitmapText({
                        text: targetMultiInst.text,
                        style: targetMultiInst.style
                    });
                    fly.x = start.x;
                    fly.y = start.y;
                    fly.anchor.set(0.5);
                    fly.scale.set(0.6);
                    fly.alpha = 1;
                    this.addChild(fly);
                    const path = [
                        { x: start.x, y: start.y },
                        {
                            x: i % 2 == 0 ? (start.x + 100) : (start.x - 100),  // lifted for arc
                            y: (start.y + 100)  // lifted for arc
                        },
                        { x: center.x, y: center.y + 100 }
                    ];
                    const tween = gsap.to(fly, {
                        delay: i * (isSuperQuickBtnOnGlobal ? 0.005 : 0.04),
                        motionPath: {
                            path: path,
                            curviness: 1.5,
                            autoRotate: false
                        },
                        x: center.x,
                        y: center.y,
                        //radius: 0,
                        duration: duration,
                        ease: "sine.inOut",
                        onStart: () => {
                            txt.visible = true;
                            //let obj = this.symbolList[i].getSlotObject("multiplier");
                            //obj?.destroy();
                            //this.symbolList[i].removeSlotObject("multiplier");
                        },
                        onComplete: () => {
                            this.activeTweens = this.activeTweens.filter((activeTween) => activeTween !== tween);
                            const totalMulti = Number(fly.text.slice(0, -1));
                            txt.text = `${textMulti + totalMulti}x`;//this.totalMulti + "X";
                            this.multiplierHitPop(txt);
                            this.removeChild(fly);
                            fly.destroy();
                            resolve();
                        }
                    });
                    this.trackTween(tween);
                });
                promises.push(promise);
            }
        }
        if (promises.length > 0)
            await Promise.all(promises);
    }

    public async collectAllMultipliersInSerial(rowNum: number, posNum: number): Promise<void> {

        const promises: Promise<void>[] = [];
        let texts = this.multiplierTextInstances;
        const duration = isSuperQuickBtnOnGlobal ? 0.25 : 0.75;
        const targetMultiInst = this.getBitmapTextByLabel(this.labelName + rowNum + "_" + posNum) as BitmapText
        const target = this.toLocal(targetMultiInst.getGlobalPosition());
        const center = new PIXI.Point(target.x, target.y);
        center.y -= this.centerOffset;
        this.totalMulti = Number(targetMultiInst.text.slice(0, -1))
        sound.play(SoundConstants.OCEAN_F, { volume: 1 });
        for (let i = 0; i < texts.length; i++) {
            if (i != 0) await wait(100);
            const txt = texts[i].text;
            if (txt != targetMultiInst) {
                const promise = new Promise<void>((resolve) => {
                    console.log(" collectAllMultipliersSpiral ===> ", txt.text);
                    const start = this.toLocal(txt.getGlobalPosition());
                    const fly = new BitmapText({
                        text: txt.text,
                        style: txt.style
                    });
                    fly.x = start.x;
                    fly.y = start.y;
                    fly.anchor.set(0.5);
                    fly.scale.set(0.6);
                    fly.alpha = 1;
                    this.addChild(fly);
                    const path = [
                        { x: start.x, y: start.y },
                        {
                            x: i % 2 == 0 ? (start.x + 100) : (start.x - 100),  // lifted for arc
                            y: (start.y + 100)  // lifted for arc
                        },
                        { x: center.x, y: center.y + 100 }
                    ];
                    const tween = gsap.to(fly, {
                        delay: i * (isSuperQuickBtnOnGlobal ? 0.005 : 0.04),
                        motionPath: {
                            path: path,
                            curviness: 1.5,
                            autoRotate: false
                        },
                        x: center.x,
                        y: center.y,
                        //radius: 0,
                        duration: duration,
                        ease: "sine.inOut",
                        onStart: () => {
                            txt.visible = true;
                            //let obj = this.symbolList[i].getSlotObject("multiplier");
                            //obj?.destroy();
                            //this.symbolList[i].removeSlotObject("multiplier");
                        },
                        onComplete: () => {
                            this.activeTweens = this.activeTweens.filter((activeTween) => activeTween !== tween);
                            this.totalMulti += Number(fly.text.slice(0, -1));
                            targetMultiInst.text = `${this.totalMulti}x`;//this.totalMulti + "X";
                            this.multiplierHitPop(targetMultiInst);
                            this.removeChild(fly);
                            fly.destroy();
                            resolve();
                        }
                    });
                    this.trackTween(tween);
                });
                promises.push(promise);
            }
        }
        if (promises.length > 0)
            await Promise.all(promises);
    }


    public resetMultipliers() {
        this.symbolList && this.symbolList.forEach((symbol) => {
            let obj;
            if (symbol) {
                const slot = symbol.skeleton?.findSlot("multiplier");
                if (slot) {
                    obj = symbol.getSlotObject("multiplier");
                    if (obj) {
                        obj.destroy();
                        symbol.removeSlotObject("multiplier");
                    }
                }
            }
        });
        this.symbolList = [];
        this.multiplierTextInstances = [];
    }

    public override destroy() {
        this.clearActiveTweens();
        this.resetMultipliers();
        super.destroy(true);
        this.symbolList = [];
        this.multiplierTextInstances = [];
    }
}